window.onload = () => {
    let featuredItemsSections = document.querySelectorAll(".featured-items");

    for (let featuredItemsSection of featuredItemsSections) {
        let featuredItemTabs = featuredItemsSection.querySelectorAll(
            ".featured-items__tab"
        );

        if (featuredItemTabs.length === 0) continue;

        let parentSection = featuredItemTabs[0].closest(".featured-items");

        for (let tab of featuredItemTabs) {
            tab.addEventListener("click", () => {
                selectNewTab(tab, parentSection);
            });

            tab.addEventListener("keyup", (e) => {
                e.preventDefault();
                if (e.code == "Enter") {
                    selectNewTab(tab, parentSection);
                }
            });
        }
    }

    let selectNewTab = (tab, parentSection) => {
        if (tab.classList.contains("active")) return;

        resetAttributes(parentSection);
        scrollToElement(tab);
        setActiveElements(tab, parentSection);
    };

    let resetAttributes = (parentSection) => {
        let activeTabConents = parentSection.querySelectorAll(
            ".featured-items__carousel.active"
        );
        let activeTabs = parentSection.querySelectorAll(
            ".featured-items__tab.active"
        );

        for (let innerTab of activeTabs) {
            innerTab.classList.remove("active");
            innerTab.setAttribute("aria-selected", "false");
        }

        for (let innerTabContent of activeTabConents) {
            innerTabContent.classList.remove("active");
            innerTabContent.setAttribute("aria-hidden", true);
            innerTabContent.setAttribute("tabindex", "-1");
        }
    };

    let scrollToElement = (el) => {
        let tabSlider = el.closest(".featured-items__tabs");

        let tabScrollPos = el.getBoundingClientRect().left;
        let tabScrollPosEnd = el.getBoundingClientRect().right;

        if (tabScrollPosEnd > window.innerWidth || tabScrollPos < 0) {
            tabSlider.scrollTo({ left: tabScrollPos, behavior: "smooth" });
        }
    };

    let setActiveElements = (tab, parentSection) => {
        let tabContentId = tab.getAttribute("id").replace("tab-", "panel-");
        let tabContentEl = parentSection.querySelector("#" + tabContentId);

        tab.classList.add("active");
        tab.setAttribute("aria-selected", "true");
        tabContentEl.classList.add("active");
        tabContentEl.setAttribute("aria-hidden", false);
        tabContentEl.setAttribute("tabindex", "0");
        // tabContentEl.focus();

        window.dispatchEvent(new Event("resize"));
    };
};
